// Whether the public catalog has anything in it.
//
// Drives hiding the Shop link: sending customers to an empty shop looks
// broken, so the nav entry and shop CTAs disappear until a product is
// published.
//
// Several components ask this on the same page (navbar, footer, home), so
// the request is shared via a module-level promise rather than fetched once
// per component.
import { useEffect, useState } from 'react';
import { getProducts } from '../services/api';

let cachedCount: Promise<number> | null = null;

const fetchCount = (): Promise<number> => {
  if (!cachedCount) {
    cachedCount = getProducts(true, false)
      .then(products => products.length)
      // A failed lookup shouldn't hide the shop — treat it as "unknown but
      // probably fine" so a blip doesn't strip the nav.
      .catch(() => 1);
  }
  return cachedCount;
};

/** Clear the cache so the next mount refetches (after publishing a product). */
export const invalidateProductCount = () => {
  cachedCount = null;
};

export const useHasProducts = () => {
  const [hasProducts, setHasProducts] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    fetchCount().then(count => {
      if (!cancelled) setHasProducts(count > 0);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  // undefined while loading, so callers can render nothing rather than
  // flashing the Shop link in and then out.
  return hasProducts;
};
